"use strict";

module.exports = {
  bindings: {
    patient: '<'
  },
  template: require('./target-lesions.html')
};



// WEBPACK FOOTER //
// ./src/main/webapp-files/modules/patients/components/tile-target-lesions/target-lesions.component.js